import { Component, OnInit } from '@angular/core';
import { QResult, Recipient, RecipientModel, SendMailModel } from '../../../../../models';
import { CoreService, HttpService } from '../../../../../services';
import { StageService } from '../../services/stage-modal.service';
import { MailService } from '../mail.service'

@Component({
  selector: 'queoval-mail-step-three',
  templateUrl: './mail-three.component.html',
  styleUrls: ['./mail-three.component.css']
})
  /*
* Composant qui sert à visualiser, modifier et envoyer le mail (Etape 3)
*/
export class MailThreeComponent implements OnInit {

  //#region Constructeur
  constructor(
    public service: StageService,
    private http: HttpService,
    private indparam: CoreService,
    public mailService: MailService,
  ) { }
  //#endregion Constructeur

  //#region Cycle de vie
  ngOnInit(): void {
 
    this.UpdateListEffectif()
  }
  //#endregion Cycle de vie

  //#region Fonctions Publics
  /**
   * récupere les infos des effectifs avant de les ajouter à la liste des destinataires
   * */
  public UpdateListEffectif() {
    if (this.mailService.modelMail.RecipientList && this.mailService.modelMail.RecipientList.length > 0) {
      this.http.postHttp<QResult<Array<Recipient>>>(`${this.indparam.AppParams.apiUrl}api/Stage/DisplayEffectif/INIT_INFO_RECIPIENT`, this.mailService.modelMail.RecipientList).subscribe(
        (data: QResult<Array<Recipient>>) => {
          if (!data.HasError) {
            this.mailService.modelMail.RecipientList = data.Value;
            this.mailService.modelMail = JSON.parse(JSON.stringify(this.mailService.modelMail));
          }
        });
    }
  }

  public reinitialiser(event: boolean) {
    if (event) {
      if (this.mailService.modelMail.Mode == 'SEND_MAIL_AUTO') {
        // Init 
        this.mailService.lstDocumentsSelected = [];
        this.mailService.modelMail = new SendMailModel();
        this.mailService.lstDestIsEmpty = true;
        this.mailService.modelMail.RecipientList = [];
        this.mailService.modelMail.ListDocAffected = [];
        // Tab Etape 1
        this.mailService.tabs[0].Active = true;
        this.mailService.tabs[1].Active = false;
        this.mailService.tabs[2].Active = false;
      }
    }
  }

  //#endregion Fonctions Publics
}
